import reducer from "./reducers";

export { default as gameOperations } from "./operations";
export { default as gameSelectors } from "./selectors";
export { default as gameTypes } from "./types";

export default reducer;
